import Cookies from 'js-cookie'
import 'select2'

const lang = document.documentElement.lang

$(function() {
    let timeout = null
    $('.products-table .products-table__images-item').hover(function() {
        let self = $(this)
        timeout = setTimeout(function () {
            $('.product-table__images-item__popup').remove();
            $('<img />')
                .addClass('product-table__images-item__popup')
                .attr('src', self.attr('src'))
                .css({'display': 'none'})
                .one("load", function(e) {
                    const top = self.offset().top - (e.target.height / 2)
                    $(this).css({
                        'display': 'block',
                        'left': self.offset().left + $(this).width() + self.width() + 20,
                        'top': top > 50 ? top : 50
                    })
                    $('body').append($(this))
                })
        }, 100)
    }, function() {
        clearTimeout(timeout)
       $('.product-table__images-item__popup').remove();
    })

    $('#app select:not(.default-select)').select2();
    /*$('#app select.pay').select2({
        escapeMarkup: function(markup) {
            return markup;
        }
    });*/

    $('select[name=region]').change(function () {
        let selected = $(this).children('option:selected').val()
        let sizes = $(this).data('sizes')[selected];
        console.log(sizes)
        let options = '';
        $.each(sizes,function (ind,val) {
            $.each(val,function (k, size) {
                options += '<option value="' + k + '">' + size + '</option>';
            });
        });
        $('select[name=size]').html(options);
    }).change()

    $('.navbar-toggler').click(function() {
        $('body').toggleClass('sidebar-icon-only');
        if ($('body').hasClass('sidebar-icon-only')) {
            Cookies.set('menu-hidden', true)
        } else {
            Cookies.remove('menu-hidden')
        }
    })
    $('.page-body-wrapper>nav .nav-item').hover(function() {
        $(this).addClass('hover-open')

    }, function() {
        $(this).removeClass('hover-open')
    })

    $('a.confirm-action').click(function() {
        let link = $(this).attr('href')
        swal({
            title: $(this).data('title'),
            text: $(this).data('desc'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3f51b5',
            cancelButtonColor: '#ff4081',
            confirmButtonText: 'Great ',
            buttons: {
                cancel: {
                    text: lang === 'ru' ? 'Отменить' : 'Cancel',
                    value: null,
                    visible: true,
                    className: "btn btn-danger",
                    closeModal: true,
                },
                confirm: {
                    text: lang === 'ru' ? 'Подтвердить' : 'Yes',
                    value: true,
                    visible: true,
                    className: 'btn btn-primary',
                    closeModal: true
                }
            }
        }).then(function(success) {
            if (success === true) {
                window.location = link;
            }
        })
        return false
    })

    $('.droplet-list .progress-bar').each(function() {
        const dropletId = $(this).closest('tr').data('id')
        const currentStatus = $(this).closest('tr').data('status')
        setInterval(function() {
            $.get(`/servers/check/${dropletId}`, res => {
                if (res.status !== currentStatus) {
                    window.location = window.location
                }
            });
        }, 5000);
    });

    $('.droplet-view .progress-bar').each(function() {
        const dropletId = $(this).data('id')
        const currentStatus = $(this).data('status')
        setInterval(function() {
            $.get(`/servers/check/${dropletId}`, res => {
                if (res.status !== currentStatus) {
                    window.location = window.location
                }
            });
        }, 5000);
    });

   $('form').on('submit', function() {
       let button = $(this).find('button[type="submit"]')
       button.attr('disabled', 'disabled')
       button.html(`<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>  ${lang === 'ru' ? 'Подождите...' : 'Loading...'}`)
   })

    $('#2fa-check').on('click', function() {
        $(this).closest('.form-group').find('button').toggleClass('d-none');
    })

    $('[data-toggle="tooltip"]').tooltip()

    $('#addqiwi').on('paste keyup', function () {
        if (parseFloat($(this).val()) <= 0) {
            $('#qiwi-info').hide();
        }
        $.post('/currency/convert', {value: $(this).val()}, function(res) {
            $('#qiwi-info').show().find('span').text(res.value);
        })
    }).keyup()

    $('#mailing-text-edidor').summernote();

   $('select[name=country]').change(function () {

       $.get(`/country/getstates/`+$('select[name=country]').val(), res => {

           $('select[name=state]').empty();
           if (Object.keys(res).length > 0)
           {
               $.each(res, function(key, value) {
                   $('select[name=state]').append('<option value="' + key + '">' + value + '</option>');
               });
               $('select[name=state]').closest('div.form-group').show();
           }
           else
           {
               $('select[name=state]').closest('div.form-group').hide();
           }




       });
   })

})
